import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { coreConfig } from 'app/app-config';
import {environment} from 'environments/environment';
import {User, Role} from 'app/auth/models';
import {ToastrService} from 'ngx-toastr';
import {config} from 'environments/config';
import {Router} from '@angular/router';
import { SgfMensajesService } from 'app/main/_services/mensajes/sgf-mensajes.service';
import { AlertService } from 'app/main/_services/alert/alert.service';

@Injectable({providedIn: 'root'})
export class AuthenticationService {
    //public
    public currentUser: Observable<User>;
    public modoEmpresa: Observable<any>;

    //private
    private currentUserSubject: BehaviorSubject<User>;
    private modoEmpresaSubject: BehaviorSubject<any>;
    public configuracion = coreConfig.app;
    /**
     *
     * @param {HttpClient} _http
     * @param {ToastrService} _toastrService
     */
    constructor(
        private _http: HttpClient,
        private _smsService: SgfMensajesService,
        private _toastrService: ToastrService,
        private _alertService: AlertService,
        private _router: Router) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();

    }


    // getter: currentUserValue
    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    cerrarSesion() {
        this.logout();
        this._router.navigate(['/auth/login']);
    }

    /**
     *  Confirms if user is admin
     */
    get isAdmin() {
        return this.currentUser && this.currentUserSubject.value.role === Role.Admin;
    }

    /**
     *  Confirms if user is client
     */
    get isClient() {
        return this.currentUser && this.currentUserSubject.value.role === Role.Client;
    }

    /**
     * User login
     *
     * @param email
     * @param password
     * @returns user
     */
    login(username: string, password: string, ip) {
        const params = new HttpParams()
            .set('username', username)
            .set('password', password)
            .set("flag", "-1")
            .set("ip", ip);
        return this._http
            .post<any>(`${config.apiUrl}/login/auth`, params)
            .pipe(
                map(user => {
                    // login successful if there's a jwt token in the response
                    if (user.status === -2) { //cuando el socio es reseteado
                        //console.log('inresa nueva clave')
                        this._alertService.clear();
                        this._alertService.success('Ingrese una nueva contraseña - con minúsculas, mayúsculas y números. Longitud mínima 6 carateres y máxima 24.');
                    }
                    if (user.list === 'WRONG_USERNAME') {
                        this._alertService.error('Usuario Incorrecto');
                    }
                    if (user.list === 'MISSING_CREDENTIAL') {
                        this._alertService.error('Póngase en contacto con la cooperativa y solicite que habiliten su clave web');
                    }
                    if (user.list === 'DISABLED') {
                        this._alertService.error('Cuenta Inactiva - Presione olvide mi contraseña para recuperar.');
                    }
                    if (user.list === 'WRONG_PASSWORD') {
                        this._alertService.error('Contraseña Incorrecta');
                    }
                    if (user.list === 'WRONG_PASSWORD_TEMP') {
                        this._alertService.error('No se ha podido generar la clave temp');
                    }
                    if (user && user.status === 1) {
                        if(this.configuracion.appSuscription === 'full') {
                        this._alertService.success('Bienvenido a la Banca web, se ha enviado un código transaccional a su teléfono o email revise por favor  Gracias! 👋 ');
                           this._toastrService.success(
                               'Bienvenido a la Banca web, se ha enviado un código transaccional a su teléfono o email revise por favor  Gracias! 👋 ', '',
                               {toastClass: 'toast ngx-toastr', closeButton: true}
                           );
                       }
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //localStorage.setItem('currentUser', JSON.stringify(user));

                        // this._smsService.mensajeLging(username,password);
                        // Display welcome toast!
                        setTimeout(() => {
                            /*this._toastrService.success(
                                'Bienvenido a la Banca web, usted accedio desde el ip: ' + ip + ' Gracias! 👋 ', '',
                                {toastClass: 'toast ngx-toastr', closeButton: true}
                            );*/
                            /* this._toastrService.success(
                               'Ha iniciado sesión con éxito como' +
                                 user.dataset.role +
                                 ' usuario a Cooperativa. Ahora puede empezar . ¡Consultar! 🎉',
                               '👋 Bienvenido, ' + user.firstName + '!',
                               { toastClass: 'toast ngx-toastr', closeButton: true }
                             );*/
                        }, 2500);

                        // notify
                        this.currentUserSubject.next(user);
                        //console.log(user)
                    }
                    return user;
                })
            );
    }

    resetPassword(usuario, email, ip) {
        const params = new HttpParams()
            .set('ci', usuario)
            .set('email', email)
            .set("token", "xxxx7887878823fgfgfgsasa@@@@ghg4523")
            .set("ip", ip);
        return this._http
            .post<any>(`${config.apiUrl}/recuperar/filter`, params)
            .pipe(
                map(user => {
                    // login successful if there's a jwt token in the response
                    if (user && user.status === 1) {
                        this.currentUserSubject.next(user);
                    }
                    return user;
                })
            );
    }

    updatePassword(token, clave, ip) {
        const params = new HttpParams()
            .set('password', clave)
            .set("token", token);
        return this._http
            .post<any>(`${config.apiUrl}/login/actualizar`, params)
            .pipe(
                map(user => {
                    // login successful if there's a jwt token in the response
                    if (user && user.status === 1) {
                        this.currentUserSubject.next(user);
                    }
                    return user;
                })
            );
    }

    public get loggedInUserValue() {
        return this.currentUserSubject.value;
    }

    public get empresaModo(){
        return this.modoEmpresaSubject.value;
    }
    /**
     * User token
     *
     */
    getToken(): any {
        // console.log(this.currentUser)
        return localStorage.getItem('currentUser');
    }

    /**
     * User caducidad
     *
     */
    getSesion(): any {
        return localStorage.getItem('fecSesion');
    }

    /**
     * User logout
     *
     */
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        // notify
        this.currentUserSubject.next(null);
    }
}
